import {
  WEBSITE_CRM_DEPLOY_PLAN_USER_PROMPT,
  WEBSITE_CRM_USER_PROMPT,
  WEBSITE_CRM_USER_PROMPT_SHORT,
} from './websiteCrmDemoContent.js'

const WEBSITE_CRM_DEMO_PROMPTS = [
  WEBSITE_CRM_USER_PROMPT,
  WEBSITE_CRM_USER_PROMPT_SHORT,
  WEBSITE_CRM_DEPLOY_PLAN_USER_PROMPT,
]

/** @param {string} trimmed */
function normalizeWebsiteCrmPrompt(trimmed) {
  return trimmed.trim().replace(/\s+/g, ' ').toLowerCase().replace(/crendential/g, 'credential')
}

/** @param {string} trimmed */
function isWebsiteCrmDeployPlanPrompt(trimmed) {
  const normalized = normalizeWebsiteCrmPrompt(trimmed)
  if (normalized === normalizeWebsiteCrmPrompt(WEBSITE_CRM_DEPLOY_PLAN_USER_PROMPT)) {
    return true
  }
  return (
    normalized.includes('create the website') &&
    normalized.includes('development plan') &&
    normalized.includes('deploy') &&
    normalized.includes('test')
  )
}

/** @param {string} trimmed */
export function isWebsiteCrmDemoPrompt(trimmed) {
  const normalized = normalizeWebsiteCrmPrompt(trimmed)
  if (
    WEBSITE_CRM_DEMO_PROMPTS.some(
      (prompt) => normalized === normalizeWebsiteCrmPrompt(prompt),
    )
  ) {
    return true
  }
  return isWebsiteCrmDeployPlanPrompt(trimmed)
}
